import React, { useEffect, useState } from "react";
import axios from "axios";
import EmployeeCornerSidebar from "./EmployeeCornerSidebar";
import BackButton from "../component/BackButton";
import { API_BASE_URL } from "../config/apiConfig";
import { FaEye } from "react-icons/fa";
import toast from "react-hot-toast";

const getDocumentUrl = (training) => {
  if (training.documentUrl) return `${API_BASE_URL}${training.documentUrl}`;
  const filename = training.documentName || training.documentPath?.split(/[\\/]/).pop();
  return filename ? `${API_BASE_URL}/api/uploads/${encodeURIComponent(filename)}` : "";
};

const EmployeeTraining = () => {
  const [trainings, setTrainings] = useState([]);
  const [loading, setLoading] = useState(true);
  const loggedUser = JSON.parse(localStorage.getItem("employeeUser") || "{}");
  const employeeUserId = loggedUser.employeeUserId;

  useEffect(() => {
    const fetchTrainings = async () => {
      if (!employeeUserId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const res = await axios.get(`/api/trainings/employee/${employeeUserId}`);
        setTrainings(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        toast.error("Error loading training documents");
      } finally {
        setLoading(false);
      }
    };

    fetchTrainings();
  }, [employeeUserId]);

  const openPdf = (base64, fileName) => {
  const byteCharacters = atob(base64);
  const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], { type: "application/pdf" });
  const blobUrl = URL.createObjectURL(blob);

  window.open(blobUrl, "_blank");
};
  return (
    <div className="flex min-h-screen flex-col md:flex-row bg-gray-50">
      <EmployeeCornerSidebar />
      <div className="flex-1 overflow-x-hidden p-3 pb-24 sm:pb-3">
        <div className="bg-white shadow-md rounded-md p-3">
          <div className="bg-dorika-blueLight border border-blue-300 rounded-lg shadow-md p-2 mb-3 sm:mb-4 flex flex-row justify-between items-center gap-2">
            <h2 className="text-sm sm:text-xl font-bold text-dorika-blue whitespace-nowrap">
              Training Documents
            </h2>
            <div className="flex shrink-0">
              <BackButton />
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full min-w-[650px] table-auto border border-gray-300 text-sm">
             <thead className="bg-gray-100">
                <tr>
                  <th className="border border-gray-300 px-2 py-2">S.No</th>
                  <th className="border border-gray-300 px-2 py-2">Date</th>
                  <th className="border border-gray-300 px-2 py-2">Start Time</th>
                  <th className="border border-gray-300 px-2 py-2">End Time</th>
                  <th className="border border-gray-300 px-2 py-2">Title</th>
                  <th className="border border-gray-300 px-2 py-2">Category</th>
                  <th className="border border-gray-300 px-2 py-2">Departments</th>
                  <th className="border border-gray-300 px-2 py-2">Documents</th>
                </tr>
              </thead>
              <tbody className="text-center">
                  {loading ? (
                    <tr><td colSpan="8" className="py-4 text-gray-500">Loading...</td></tr>
                  ) : trainings.length ? (
                    trainings.map((t, index) => (
                      <tr key={t._id} className="hover:bg-gray-50">
                        <td className="border border-gray-300 px-2 py-2">{index + 1}</td>
                        <td className="border border-gray-300 px-2 py-2">{t.trainingDate}</td>
                        <td className="border border-gray-300 px-2 py-2">{t.startTime}</td>
                        <td className="border border-gray-300 px-2 py-2">{t.endTime}</td>
                        <td className="border border-gray-300 px-2 py-2">{t.trainingTitle}</td>
                        <td className="border border-gray-300 px-2 py-2">{t.trainingCategory}</td>
                        
                        {/* Department Array handling */}
                        <td className="border border-gray-300 px-2 py-2">
                          {Array.isArray(t.departments) ? t.departments.join(", ") : t.departments}
                        </td>

                       <td className="border border-gray-300 px-2 py-2">
                          {t.documentPaths?.map((base64, i) => (
                            <button
                              key={i}
                              onClick={() => openPdf(base64, t.documentNames?.[i])}
                              className="text-blue-600 underline block text-xs"
                            >
                              {t.documentNames?.[i] || `PDF ${i + 1}`}
                            </button>
                          ))}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan="8" className="py-4 text-gray-500">No training documents found.</td></tr>
                  )}
                </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeTraining;
